import { Button, Grid } from '@material-ui/core';
import React from 'react';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import DialogSignUp from './DialogSignUp';


export default class AdminBeneficiari extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            societati: [],
            numeSocietate: '',
            cui: '',
            numeUser: '',
            email: '',
            parola: '',
            repetaParola: '',
            labRez: '',
            openSignUp: false,
            loading: false
        }
    }

    componentDidMount() {
        this.checkAndLogin()
        // this.getData()
    }


    ws = new Ws();
    ls = new LocalStorage();
    u = new Utils();

    checkAndLogin = async () => {

        let loginServerResponse = await this.ws.login(`admin.bogdan@fonduristructurale.com`, '123456');
        // let loginServerResponse = await WS.postData('Login/Loginup',{email:this.state.strEmail, parolac:this.state.strP})
        // console.log('loginServerResponse = ', loginServerResponse)


        console.log('loginServerResponse :>> ', loginServerResponse);
        if (loginServerResponse.Succes) {

            await this.ls.SetUserData(loginServerResponse.Content)


            this.getData()
            // console.log('All right simulare save = ')



        } else {
            this.setState({ labRez: loginServerResponse.Message })
        }
        // let toSave = {idUser:'777', nume:'Popescu'}

    }


    getData = async () => {


        let getSocietati = await this.ws.customSelect(`select * from pm_logator.[dbo].societati`, {
            p1: 1
        })


        console.log('getSocietati :>> ', getSocietati);


        if (getSocietati.Succes) {
            this.setState({ societati: getSocietati.Content })
        }
    }


    openNewSocietate = () => {
        this.setState({
            openSignUp: true,
            numeSocietate: '',
            cui: '',
            numeUser: '',
            email: '',
            parola: '',
            repetaParola: '',
            labRez: ''
        })
    }

    handleChange = (ev) => {
        let val = ev.target.value
        let n = ev.target.name

        console.log('n :>> ', n);
        console.log('val :>> ', val);

        this.setState({ [n]: val })
    }


    checkAndSignUp = async () => {


        if (this.state.parola.length > 5) {


            if (this.state.parola === this.state.repetaParola) {

                this.setState({ loading: true },async () => {
                    let addr = `${this.ws.loginServerAddress}Beneficiari/Create?acceskey=78329hcd9wucnddsu9dk&numeSocietate=${this.state.numeSocietate}&cui=${this.state.cui}&numeUser=${this.state.numeUser}&email=${this.state.email}&parola=${this.state.parola}`


                    console.log('addr :>> ', addr);


                    addr = encodeURI(addr)

                    let r = await fetch(addr)

                    let insertSocietate = await r.json()

                    console.log('insertSocietate :>> ', insertSocietate);


                    if (insertSocietate.Succes) {



                        this.ls.SetUserData(insertSocietate.Content)


                        let objInsertDep = {
                            nume: 'GM',


                        }

                        let objAngajat = {
                            id_categorie: 1,
                            nume: this.state.numeUser || '',
                            email: this.state.email || '',
                            id_user: insertSocietate.Content.InfoUser.IdUser,
                            data_angajarii: this.u.updateSqlNow()
                        }


                        let insertDep = this.ws.insert('departamente', objInsertDep)


                        let insertA = this.ws.insert('angajati', objAngajat)


                        let [iD, iA] = await Promise.all([insertDep, insertA])


                        if (iD.Succes && iA.Succes) {

                            let iUserDrepturi = this.ws.insert('useri_drepturi', {
                                id_utilizator: insertSocietate.Content.InfoUser.IdUser,

                                profil_selectat: 'Manager',

                                acces_rapoarte: 1,
                                acces_setari: 1,
                                acces_utilizatori: 1,

                                acces_extins_proiecte: 1,

                                acces_evaluari: 1,
                                can_edit_evaluari: 1,

                                acces_monitorizare: 1,
                                can_edit_monitorizare: 1,

                                sterge_proiecte: 1

                            })

                            let insertD = this.ws.insert('angajati_departamente', {
                                id_angajat: iA.Content[0].id,
                                id_departament: iD.Content[0].id,
                                sef_departament: 1
                            })


                            let objToInsertDisplay = {
                                margintop: 50,
                                marginleft: 100,
                                id_departament: iD.Content[0].id
                            }

                            let insertDisplay = this.ws.insert('organigrama_display_data', objToInsertDisplay)



                            let [iUD, iDep, iDisp] = await Promise.all([iUserDrepturi, insertD, insertDisplay])

                            if (iUD.Succes && iDep.Succes && iDisp.Succes) {

                                let getUserRights = await this.ws.customSelect('select * from useri where id = @p1', {
                                    p1: this.ls.GetUserData().InfoUser.IdUser
                                })


                                if (getUserRights.Succes) {
                                    let obj = this.ls.GetUserData();

                                    obj.InfoUser.IsAdmin = getUserRights.Content[0].is_admin
                                    obj.InfoUser.DrepturiAngajati = getUserRights.Content[0].modifica_angajati
                                    obj.InfoUser.AccesProiecte = getUserRights.Content[0].access_proiecte
                                    obj.InfoUser.CreazaProiecte = getUserRights.Content[0].creaza_proiecte
                                    obj.InfoUser.EsteSef = getUserRights.Content[0].sef_departament
                                    obj.InfoUser.AccessFinanciar = getUserRights.Content[0].access_financiar


                                    this.ls.SetUserData(obj)

                                    let insertDate = await this.ws.insert('companie_date', {
                                        nume:this.state.numeSocietate,
                                        adresa: 'Introdu Adresa',
                                        cui: this.state.cui,
                                        nr_inregistrare: 0,
                                        cota_tva: 0
                                    })
    
                                    if(insertDate.Succes){
                                        console.log('insertDate :>> ', insertDate);
                                        this.props.history.push('/');
                                        document.location.reload();
                                    }

                                } else {
                                    this.setState({ labRez: getUserRights.Messsage })
                                }
                            }

                        }

                    } else {
                        if (insertSocietate.Content.showMessageToUser) {
                            this.setState({ labRez: insertSocietate.Messsage,
                                            loading:false })
                        } else {
                            this.setState({ labRez: 'Eroare Tehnica, va rugam reveniti !',
                                            loading:false })
                        }

                    }
                })











            } else {
                this.setState({
                    labRez: 'Parolele nu coincid!',
                    loading: false
                })
            }

        } else {
            this.setState({
                labRez: 'Parola trebuie sa fie mai mare de 5 caractere',
                loading: false
            })
        }

    }


    render() {
        return (
            <div>

                <DialogSignUp
                    open={this.state.openSignUp}
                    dialogClose={() => { this.setState({ openSignUp: false }) }}
                    numeSocietate={this.state.numeSocietate}
                    cui={this.state.cui}
                    numeUser={this.state.numeUser}
                    email={this.state.email}
                    parola={this.state.parola}
                    repetaParola={this.state.repetaParola}
                    labRez={this.state.labRez}
                    handleChange={this.handleChange}
                    checkAndSignUp={this.checkAndSignUp}
                    loading={this.state.loading}
                />



                <Grid style={{ maxWidth: 1000, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container >


                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>Societati </h1>
                            </Grid>

                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, maxWidth: 1000, margin: 'auto' }}>
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 18, fontWeight: 800, color: 'black', marginBottom: 40, display: 'flex', justifyContent: 'space-between' }}>
                                        Lista Societati
                                    </h4>
                                </Grid>

                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} style={{ textAlign: 'right', paddingTop: 15 }}>
                                    <Button style={{ textTransform: 'none', display: 'inline-block', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.openNewSocietate}  >
                                        Societate Noua
                                    </Button>

                                </Grid>

                                {this.state.societati.map((s, idx) => {
                                    return (
                                        <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Grid style={{
                                                padding: 10,
                                                backgroundColor: '#FAFAFA',
                                                marginBottom: 20
                                            }} container>




                                                <Grid style={{ textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <span style={{ fontWeight: 400, fontSize: 14 }}>Nume </span><br />
                                                    <span style={{
                                                        fontSize: 12,
                                                        color: '#777777',
                                                        fontWeight: 400
                                                    }}>{s.nume}</span>
                                                </Grid>

                                                <Grid style={{ textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <span style={{ fontWeight: 400, fontSize: 14 }}>CUI </span><br />
                                                    <span style={{
                                                        fontSize: 12,
                                                        color: '#777777',
                                                        fontWeight: 400
                                                    }}>{s.cui} </span>
                                                </Grid>

                                            </Grid>
                                        </Grid>
                                    )
                                })}

                                <Grid style={{ textAlign: 'right' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button style={{ textTransform: 'none', display: 'block', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.openNewSocietate}  >
                                        Societate Noua
                                    </Button>

                                </Grid>

                            </Grid>


                        </Grid>
                    </Grid>
                </Grid>
            </div >
        );
    }
}